/* global $, Forms, Option */

window['leads#new'] = function () {
  $('#lead_client_company_id').on('change', function () {
    const companyId = this.value
    $.getJSON(`/client_companies/${companyId}/contact_people.json`, function (data) {
      populateContactPeople('#lead_contact_person_id', data)
      populateContactPeople('#lead_decider', data)
    })
  })

  function populateContactPeople (selector, data) {
    const select = $(selector)
    select.select2('destroy')
    select.empty()
    select.append(new Option())

    data.forEach(elem => {
      select.append(new Option(elem.name.name, elem.id))
    })

    Forms.initSelect2(select)
  }
}

window['leads#edit'] = window['leads#new']
